export const getCookieValue = (name: string): string | undefined => {
  const key = `${name}=`;
  const match = document.cookie
    .split(';')
    .map((cookiePart) => cookiePart.trim())
    .find((cookiePart) => cookiePart.startsWith(key));
  if (!match) return undefined;
  return decodeURIComponent(match.substring(key.length));
};

export const setCookieValue = (name: string, value: string, expiresInDays: number): void => {
  const expires = new Date(Date.now() + expiresInDays * 24 * 60 * 60 * 1000).toUTCString();
  document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=/`;
};
